<script setup>
  import { useWishlistStore } from '@/stores/wishlist'
  import { storeToRefs } from 'pinia'

  const store = useWishlistStore()
  const { hasWishlistAccepted, showWarning } = storeToRefs(store)

  const props = defineProps({
    headline: String,
    text: String
  });

  const acceptWishlist = async () => {
    await store.acceptWishlist()
    await hideWishlistWarning()
  }

  const hideWishlistWarning = () => {
    store.hideWishlistWarning()
  }

</script>

<template>
  <div
    v-if="!hasWishlistAccepted && showWarning"
    class="fixed h-screen w-screen bg-black bg-opacity-50 top-0 left-0 flex items-center justify-center z-50"
  >
    <div
      class="wishlist-modal bg-white ~p-10/16 w-[95%] max-w-xl relative"
    >
      <button
        class="wishlist-modal-close absolute ~top-3/5 ~right-3/5"
        aria-label="Dialog Schließen"
        @click="hideWishlistWarning"
      >
        <AppIcon
          name="Close"
        />
      </button>
      <h2
        class="~text-lg/2xl font-bold mb-5"
      >
        {{ props.headline }}
      </h2>
      <span
        class="block mb-5"
        v-html="props.text"
      />
      <button
        class="btn btn-primary"
        @click="acceptWishlist()"
      >
        Merkliste akzeptieren
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .wishlist-modal-close :deep(svg) {
    @apply w-4 h-4;
  }
  .wishlist-modal-close :deep(svg path) {
    @apply fill-black !important;
  }
  :deep(p) {
    @apply mb-5 ~text-sm/base;
  }
</style>
